import React, { useEffect, useState } from 'react';

import logo from '../static/images/logo_01.svg';

import handleChat from '../utils/handle-chat';
import handleGa from '../utils/handle-ga';

import './menu.css';
import Button from './button';

function throttle(fn, interval = 1000) {
  let timer = null;
  return function(...args) {
    if (!timer) {
      timer = setTimeout(() => {
        timer = null;
        fn.call(this, ...args);
      }, interval);
    }
  };
}

const getActiveDom = (contrainer, anchores) => {
  let activeId = '';
  const windowHeight = contrainer.offsetHeight;
  anchores.forEach(element => {
    const id = element.hash.slice(1);
    const target = document.getElementById(id);
    if (target && !activeId) {
      const { top } = target.getBoundingClientRect();
      // 当元素头部可见时
      if (top >= -100 && top < windowHeight) {
        activeId = id;
      }
    }
  });
  return activeId;
};

const data = [
  { label: '首页', href: '#home' },
  { label: '在线客服', href: '#online-service' },
  { label: '外呼插件', href: '#call-plugin' },
  { label: '音视频通讯', href: '#audio-video' },
  { label: '在线表单', href: '#online-form' },
  { label: '微信客服', href: '#wechat-agent' },
  { label: '多客助手', href: '#duoke-assistant' }
];
const Menu = props => {
  const { type = 'normal' } = props;
  const menuData = type === 'single' ? data.slice(0, 1) : data;
  const { hash } = window.location;
  const [activeHref, setActiveHref] = useState(hash === '#detail' ? '#detail' : '#home');

  const onScroll = () => {
    const anchores = document.querySelectorAll('.custom-anchor');
    const container = document.querySelectorAll('body')[0];
    const id = getActiveDom(container, anchores);
    if (id) {
      setActiveHref(`#${id}`);
    }
  };

  const handleNav = label => {
    const type = window.sessionStorage.getItem('_FIRST_PAGE_TYPE');
    handleGa('导航', [type, `导航-${label}`]);
  };

  const handleHome = () => {
    const type = window.sessionStorage.getItem('_FIRST_PAGE_TYPE');
    window.location.hash = '#home';
    handleGa('导航', [type, '导航-首页']);
  };

  const throttleFn = throttle(onScroll, 200);
  useEffect(() => {
    document.addEventListener('scroll', throttleFn, { passive: true });
    return () => {
      document.removeEventListener('scroll', throttleFn, { passive: true });
    };
  }, [throttleFn]);

  return (
    <header className="custom-menu">
      <div className="menu-before">
        <img src={logo} alt="多客" onClick={() => handleHome()} />
      </div>
      <ul>
        {menuData.map(val => {
          const { label, href } = val;
          return (
            <li key={href} className={`${activeHref === href ? 'active' : ''}`}>
              <a className="custom-anchor" href={href} onClick={() => handleNav(label)}>
                {label}
              </a>
            </li>
          );
        })}
      </ul>
      <div className="menu-after">
        <Button type="primary" size="small" onClick={() => handleChat('立即购买', ['n1', 'type1'])}>
          立即购买
        </Button>
        <Button size="small" onClick={() => handleChat('免费试用', ['n1', 'type2'])}>
          免费试用
        </Button>
      </div>
    </header>
  );
};

export default Menu;
